import { Image } from "antd-mobile";
import { useState } from "react";
import { isDemoGame, useGameLogin } from "../../../../../../context/GameLoginContext";
import { useLogin } from "../../../../../../context/LoginContext";
import localStorageKey from "../../../../../../enumerations/localStorageKey";
import { envChangeType } from "../../../../../../plugins/utils";
import "./style.scss";
import styles from "./styleModule";

const GameItem = ({
  isPopup = false,
  isFromSearch = false,
  game,
  gameNameStyle = "",
  gameItemImageContainerStyle = "",
  gameBadgeStyle = "",
  maintainImageStyle = "",
  gameRecentStyle = "",
  gameItemPlatformStyle = "",
  grayScale = false,
}) => {
  const { handleLoginGame, handleDemoGame } = useGameLogin();
  const { checkIfLogin } = useLogin();
  const [imageLoaded, setImageLoaded] = useState(false);
  const language =
    localStorage.getItem(localStorageKey.LANG_SETTING) ?? envChangeType("REACT_APP_DEFAULT_LANG");
  const renderMaintain = (game) => {
    if (game?.maintenance_status === 0) return null;
    return (
      <div
        className={`${styles.maintain} ${maintainImageStyle} ${
          grayScale === true ? styles.removeMask : ""
        }`}
      >
        <Image
          src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/game_maintain.png`}
          alt={`${game.game_code} maintenance`}
          className={`${styles.maintainImg}`}
          placeholder={false}
        />
      </div>
    );
  };

  const renderHot = (game) => {
    if (game?.is_hot === 0) return null;
    return (
      <Image
        src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/hot_game.png`}
        alt={`${game.game_code} hot`}
        className={`${styles.badge} ${gameBadgeStyle}`}
        placeholder={false}
      />
    );
  };

  const renderRecent = (game) => {
    if (!game?.is_recent) return null;
    return (
      <Image
        src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/recent.svg`}
        alt={`${game.game_code} recent`}
        className={`${styles.recentBadge} ${gameRecentStyle}`}
        placeholder={false}
      />
    );
  };

  const onGameClick = () => {
    if (game?.maintenance_status === 1) return;
    // OMG / AG 遊戲未登入時，登入提示多一顆「試玩」
    const onDemo = isDemoGame(game?.game_3th_code)
      ? () => handleDemoGame({ game3th: { game_3th_code: game?.game_3th_code }, gameItem: game })
      : undefined;
    if (!checkIfLogin({ onDemo })) return;
    handleLoginGame({
      isPopup: isPopup,
      isFromSearch: isFromSearch,
      game3th: { game_3th_code: game?.game_3th_code },
      gameItem: game,
    });
  };

  const handleImageLoad = () => {
    setImageLoaded(!imageLoaded);
  };

  const renderGameName = () => {
    if (language === "zh") {
      return game?.name?.replaceAll(/\u00a0/g, " ");
    }
    return game?.en_name?.replaceAll(/\u00a0/g, " ");
  };

  return (
    <div className={styles.gameItemContainer} onClick={onGameClick}>
      <div className={styles.gameImageContainer}>
        {/* {renderHot(game)} */}
        {renderRecent(game)}
        {/* {imageLoaded ? (
          <Image
            className={`${styles.platformImage} ${gameItemPlatformStyle}`}
            src={`/images/platform/logo/${game.game_3th_code}.png`}
            alt={game?.game_3th_code}
            placeholder={false}
          />
        ) : (
          ""
        )} */}
        <div className={styles.gameImageWrapper}>
          <Image
            className={`${styles.gameImage} ${gameItemImageContainerStyle} ${
              grayScale === true ? (game?.maintenance_status === 0 ? "" : styles.maintainImg) : ""
            } game-item-image`}
            src={game?.en_img_url}
            alt={game?.game_code}
            placeholder={
              <Image
                src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/game_loading.png`}
                className={styles.placeholder}
                placeholder={false}
              />
            }
            // onLoad={handleImageLoad}
          />
          <div className={styles.gameBrand}>
            <Image
              src={`/images/platform/brand/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${game.game_3th_code}.png`}
              alt={`${game.game_code} hot`}
              height={14}
              preview={false}
            />
          </div>
        </div>

        {renderMaintain(game)}
      </div>
      <div className={styles.gameNameContainer}>
        {/* {imageLoaded ? ( */}
        <div className={`${styles.gameName} ${gameNameStyle}`}>{renderGameName()}</div>
        {/* ) : (
          ""
        )} */}
      </div>
    </div>
  );
};
export default GameItem;
